<template>
    <bs-v-img
        :src="start ? (graphic.metadata || {}).start : graphic.image"
        :lazy-src="(graphic.metadata || {}).lazy_thumb"
        :alt="graphic.title"
        class="bg-grey-lighten-2"
        :aspect-ratio="aspectRatio"
    >
        <template #placeholder>
            <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
            >
                <v-progress-circular
                    indeterminate
                    :class="['secondary--text']"
                ></v-progress-circular>
            </v-row>
        </template>
    </bs-v-img>
</template>

<script setup>
import {computed, toRefs,} from 'vue'

const props = defineProps({
    graphic: {
        type: Object,
        default: ()=>({}),
    },
    start: {
        type: Boolean,
        default: false,
    },
})

const {graphic,start,} = toRefs(props)
const aspectRatio = computed(()=>{
    let graphicEntity = graphic.value
    let width = parseInt((graphicEntity.metadata?.size ?? {}).width) || 1
    let height = parseInt((graphicEntity.metadata?.size ?? {}).height) || 1

    return width / height
})
</script>

<style lang="scss" scoped>
.v-img {
    border-radius: map-deep-get($bs-xl, autocomplete, inputRadius);
}
</style>
